const processLocalize = {
  "process successfully updated": "Process successfully updated",
  "process successfully deleted": "Process successfully deleted",
  "already exists a process with this description": "Already exists a process with this description"
};

export default processLocalize;